import { action } from "typesafe-actions";
import { IPromocode } from "./promocode.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import { closeLoaderWithMessage, openLoaderWithMessage, showMessage } from "../messages/messagesActions";
import { endPoints } from "../../constants/endPoints";
import { ISearchQueryParams } from "../common/common.types";
import { getSearchQueryV2 } from "../common/helpers";

// Fetch Promocode List Actions
export const FETCH_PROMOCODE_LIST_PROGRESS = "FETCH_PROMOCODE_LIST_PROGRESS";
export const FETCH_PROMOCODE_LIST_SUCCESS = "FETCH_PROMOCODE_LIST_SUCCESS";
export const FETCH_PROMOCODE_LIST_FAILED = "FETCH_PROMOCODE_LIST_FAILED";

export const fetchPromocodeListProgress = () => action(FETCH_PROMOCODE_LIST_PROGRESS);
export const fetchPromocodeListSuccess = (list: IPromocode[], totalRecords: number) =>
  action(FETCH_PROMOCODE_LIST_SUCCESS, { list, totalRecords });
export const fetchPromocodeListFailed = () => action(FETCH_PROMOCODE_LIST_FAILED);

export const fetchPromocodeListAsync =
  (
    queryParams: ISearchQueryParams
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchPromocodeListProgress());

      let url = getSearchQueryV2(queryParams);

      const res = await api.get(`${endPoints.promocode.getPromocode}?${url}`);
      const data: IPromocode[] = res.data.data || [];
      const totalRecords = res.data.totalRecords || 0;

      dispatch(fetchPromocodeListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchPromocodeListFailed());
      dispatch(
        showMessage({
          message: err?.response?.data?.message || "Failed to fetch promocodes",
          type: "error",
          displayAs: "snackbar",
        })
      );
    }
  };

// Fetch Single Promocode Actions
export const FETCH_PROMOCODE_PROGRESS = "FETCH_PROMOCODE_PROGRESS";
export const FETCH_PROMOCODE_SUCCESS = "FETCH_PROMOCODE_SUCCESS";
export const FETCH_PROMOCODE_FAILED = "FETCH_PROMOCODE_FAILED";

export const fetchPromocodeProgress = () => action(FETCH_PROMOCODE_PROGRESS);
export const fetchPromocodeSuccess = (promocode: IPromocode) =>
  action(FETCH_PROMOCODE_SUCCESS, { promocode });
export const fetchPromocodeFailed = (errorMessage: string) =>
  action(FETCH_PROMOCODE_FAILED, { errorMessage });

export const fetchPromocodeAsync =
  (promocodeId: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchPromocodeProgress());

      const res = await api.get(`${endPoints.promocode.getPromocode}?pageNo=1&itemPerPage=10&rsa_promocode_uuid=${promocodeId}`);
      const data: IPromocode = res.data.data[0];

      dispatch(fetchPromocodeSuccess(data));
    } catch (err: any) {
      dispatch(
        fetchPromocodeFailed(
          err?.response?.data?.message || "Failed to fetch promocode"
        )
      );
      dispatch(
        showMessage({
          message: err?.response?.data?.message || "Failed to fetch promocode",
          type: "error",
          displayAs: "snackbar",
        })
      );
    }
  };

// Upsert Promocode Actions
export const upsertPromocodeAsync =
  (
    promocodeData: IPromocode,
    onCallBack: (isSuccess?: boolean, data?: IPromocode) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(openLoaderWithMessage("Saving promocode, please wait..."));
      const {
        create_ts,
        insert_ts,
        created_by_name,
        created_by_uuid,
        modified_by_name,
        modified_by_uuid,
        ...payload
      } = promocodeData;
      
      const res = await api.post(endPoints.promocode.upsertPromocode, payload);
      
      const data: IPromocode = res?.data?.data;
      dispatch(
        showMessage({
          message: res?.data?.message || "Promocode saved successfully",
          type: "success",
          displayAs: "snackbar",
        })
      );
      onCallBack(true, data);
    } catch (err: any) {
      dispatch(
        showMessage({
          message: err?.response?.data?.message || "Failed to save promocode",
          type: "error",
          displayAs: "snackbar",
        })
      );
      onCallBack(false);
    } finally {
      dispatch(closeLoaderWithMessage());
    }
  };

// Clear Actions
export const CLEAR_PROMOCODE_STATE = "CLEAR_PROMOCODE_STATE";
export const CLEAR_PROMOCODE = "CLEAR_PROMOCODE";

export const clearPromocodeState = () => action(CLEAR_PROMOCODE_STATE);
export const clearPromocode = () => action(CLEAR_PROMOCODE);
